import { apolloClient } from '@/apollo';
import CAMPAIGN from '@/graphql/Campaigns/Campaign.gql';
import REMOVE_CAMPAIGN from '@/graphql/Campaigns/RemoveCampaign.gql';
import UPDATE_WIDGET from '@/graphql/Campaigns/UpdateWidget.gql';
import COMPANY from '@/graphql/Companies/Company.gql';
import COMPANY_BALANCES from '@/graphql/Balance/CompanyBalances.gql';
import COMPANY_BALANCES_FOR_ADMIN from '@/graphql/Balance/AdminCompanyBalances.gql';
import mixpanel from '@/helpers/mixpanel';

export default {
  login({ dispatch }, auth) {
    dispatch('setAuth', auth);
    localStorage.setItem('auth', JSON.stringify(auth));
    dispatch('prepForClient');
  },

  logout({ commit }) {
    commit('setAuth', null);
    localStorage.removeItem('auth');
    sessionStorage.removeItem('signupStep');
    sessionStorage.removeItem('landingUrl');
    sessionStorage.removeItem('newCampaignId');
  },

  checkAuth({ dispatch }) {
    const auth = localStorage.getItem('auth');
    if (auth) {
      dispatch('setAuth', JSON.parse(auth));
    }
    dispatch('prepForClient');
  },

  checkWhiteLabel({ commit }) {
    const hostname = window.location.hostname;
    commit('setWhiteLabel', !hostname.includes('nextlead'));
  },

  setAuth({ commit, dispatch, getters }, auth) {
    commit('setAuth', auth);
    const getAuthUser = auth.user;
    if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
      mixpanel.identify(getAuthUser.companyId);
    }
    dispatch('trackEvent', { name: 'Signin' });
  },

  trackEvent({ getters }, { name, options }) {
    const getAuthUser = getters.getAuthUser;
    if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
      mixpanel.track(name, options);
    }
  },

  // trackAffilate ({getters}, {affiliateId} ) {
  //   const getAuthUser = getters.getAuthUser;
  //   if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
  //     mixpanel.people.set({ affiliateId });
  //   }
  // },

  prepForClient({ dispatch, getters }) {
    const getAuthUser = getters.getAuthUser;
    if (getAuthUser && getAuthUser.role && getAuthUser.role.role_type === 'client') {
      const companyId = +getAuthUser.companyId;
      dispatch('fetchCompany', companyId);
      dispatch('fetchCompanyBalances', companyId);

      // try {
      //   window.fcWidget.init({
      //     token: "e901e1f5-db22-478a-bd36-e3c7516c3e86",
      //     host: "https://wchat.freshchat.com"
      //   });
      //
      //   window.fcWidget.setExternalId(getAuthUser.id);
      //   window.fcWidget.user.setFirstName(getAuthUser.name);
      //   window.fcWidget.user.setEmail(getAuthUser.email);
      //   window.fcWidget.user.setPhone(getAuthUser.phone);
      // } catch (e) {
      //   // eslint-disable-next-line
      //   console.log(e);
      // }
    }
  },

  toggleMenu({ commit }) {
    commit('toggleMenu');
  },

  checkCurrentStep({ commit }) {
    const savedStep = sessionStorage.getItem('signupStep');
    if (savedStep) {
      commit('setLastSignupStep', +savedStep);
    }
    const landingURL = sessionStorage.getItem('landingURL');
    if (landingURL) {
      commit('setLandingUrl', landingURL);
    }
    const newCampaignId = sessionStorage.getItem('newCampaignId');
    if (newCampaignId) {
      commit('setNewCampaignId', newCampaignId);
    }
  },

  submitStep({ commit }, step) {
    const nextStep = step + 1;
    sessionStorage.setItem('signupStep', nextStep);
    commit('setLastSignupStep', nextStep);
  },

  saveLandingUrl({ commit }, landingURL) {
    sessionStorage.setItem('landingURL', landingURL);
    commit('setLandingUrl', landingURL);
  },

  saveNewCampaignId({ commit }, campaignId) {
    sessionStorage.setItem('newCampaignId', campaignId);
    commit('setNewCampaignId', campaignId);
  },

  async fetchCompany({ commit }, companyId) {
    const { data } = await apolloClient.query({
      query: COMPANY,
      variables: { id: companyId },
      fetchPolicy: 'network-only',
    });
    const company = {
      id: data.company.id,
      companyName: data.company.companyName,
      description: data.company.description,
      website: data.company.website,
      address: data.company.address,
      currency: data.company.currency,
      status: data.company.status,
      stripeCustomerId: data.company.stripeCustomerId,
      stripeSourceId: data.company.stripeSourceId,
      overdue: data.company.overdue,
    };
    commit('setCompany', company);
  },

  async fetchCompanyBalances({ commit, getters }, companyId) {
    const { data } = await apolloClient.query({
      query: getters.isUserAdmin ? COMPANY_BALANCES_FOR_ADMIN : COMPANY_BALANCES,
      variables: { id: companyId },
      fetchPolicy: 'network-only',
    });
    commit('setCompanyBalances', data.balances);
  },

  async fetchCampaign({ commit }, campaignId) {
    const { data } = await apolloClient.query({
      query: CAMPAIGN,
      variables: { id: parseInt(campaignId) },
      fetchPolicy: 'network-only',
    });
    const campaign = {
      campaignName: data.campaign.campaignName,
      created: data.campaign.created,
      dispatchTo: data.campaign.dispatchTo,
      dispatchToPhone: data.campaign.dispatchToPhone,
      id: data.campaign.id,
      status: data.campaign.status,
      editable: data.campaign.editable,
      whiteLabel: data.campaign.whiteLabel,
      widget: JSON.parse(data.campaign.widget),
      company: data.campaign.company,
      type: data.campaign.type,
    };
    commit('setCampaign', campaign);
  },

  async deleteCampaign({ commit }, campaignId) {
    await apolloClient.mutate({
      mutation: REMOVE_CAMPAIGN,
      variables: { id: campaignId },
    });
    commit('setCampaign', { widget: {} });
  },

  async updateWidget({ commit, getters }) {
    const campaign = getters.campaign;
    await apolloClient.mutate({
      mutation: UPDATE_WIDGET,
      variables: {
        id: campaign.id,
        input: campaign.widget,
      },
    });
    const newCampaign = {
      ...campaign,
      widget: campaign.widget,
    };
    commit('setCampaign', newCampaign);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js